import almoxarifado from './almoxarifado'
import cadastros from './cadastros'

export default [
  ...cadastros,
  ...almoxarifado,
];
